export const GET_SESSION_SURVEY_REQUEST = 'GET_SESSION_SURVEY_REQUEST';
export const GET_SESSION_SURVEY_SUCCESS = 'GET_SESSION_SURVEY_SUCCESS';
export const GET_SESSION_SURVEY_FAILURE = 'GET_SESSION_SURVEY_FAILURE';

export function getSessionSurvey(webinarKey, sessionKey) {
  return {
    type: GET_SESSION_SURVEY_REQUEST,
    payload: { webinarKey, sessionKey }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionSurvey/SessionSurveyActions.js